<script setup lang="ts">
  import { computed } from 'vue'
  import { type TenantUser } from '@gat-ship/types'
  import { DataList } from '@gat-ship/vue-components'
  import { useTenantUsersCollectionContext } from '../../composables/useTenantUsersCollection'
  import { useTenantUserSelectors } from '../../composables/useTenantUserSelectors'
  import TenantUserListItem from './TenantUserListItem.vue'

  // Router-agnostic list body shared by the routed TenantUsersView (under its
  // PageLayout chrome) and the AdministrationModal tenant-users panel. The host
  // owns the tab/search/sort state, the surrounding header, and what a row
  // click does (route navigation vs. opening the detail modal) — this component
  // only filters + renders the rows and emits `select`.
  const props = withDefaults(
    defineProps<{
      /** Filter mode: `active` | `inactive` | anything else = show all. */
      activeTab: string
      search: string
      sortBy?: string
    }>(),
    { sortBy: 'default' }
  )

  const emit = defineEmits<{
    (e: 'select', user: TenantUser): void
  }>()

  const { filterTenantUsersForList, sortTenantUsersByName } =
    useTenantUserSelectors()
  const tenantUsersProvider = useTenantUsersCollectionContext()!

  const _data = computed(() =>
    sortTenantUsersByName(
      filterTenantUsersForList(tenantUsersProvider.tenantUsers.value, {
        activeTab: props.activeTab,
        search: props.search
      }),
      props.sortBy
    )
  )
</script>

<template>
  <DataList>
    <TenantUserListItem
      v-for="tenantUser in _data"
      :key="tenantUser.userId"
      :tenant-user="tenantUser"
      @click="emit('select', tenantUser)"
    />
  </DataList>
</template>
